import {
  BenchmarkReportCategoriesMap,
  BenchmarkReportCategory,
} from 'spw-redux/modules/benchmark-reports/types';
import {
  AMENITY_SPACES_CATEGORY,
  CUSTOM_SUBCATEGORY,
  INDIVIDUAL_WORKSPACES_CATEGORY,
  MEETING_SPACES_CATEGORY,
  PRIVATE_OFFICES_SUBCATEGORY,
  SHARED_SPACES_CATEGORY,
  SUPPORT_SPACES_CATEGORY,
  WORKSTATIONS_SUBCATEGORY,
} from 'spw-constants';
import { IProjectColors } from 'spw-redux/modules/projects/types';

export const DEFAULT_CATEGORIES_MAP: BenchmarkReportCategoriesMap = {
  [INDIVIDUAL_WORKSPACES_CATEGORY]: {
    name: 'INDIVIDUAL WORKSPACES',
    color: '#A967E8',
    gradientColorIndex: null,
  },
  [MEETING_SPACES_CATEGORY]: {
    name: 'MEETING SPACES',
    color: '#40B6F9',
    gradientColorIndex: null,
  },
  [AMENITY_SPACES_CATEGORY]: {
    name: 'AMENITY SPACES',
    color: '#F58D8D',
    gradientColorIndex: null,
  },
  [SUPPORT_SPACES_CATEGORY]: {
    name: 'SUPPORT SPACES',
    color: '#6FCF97',
    gradientColorIndex: null,
  },
  [CUSTOM_SUBCATEGORY]: {
    name: 'OTHER WORKPOINTS',
    color: '#A967E8',
    gradientColorIndex: 6,
  },
  [WORKSTATIONS_SUBCATEGORY]: {
    name: 'WORKSTATIONS',
    color: '#A967E8',
    gradientColorIndex: 15,
  },
  [PRIVATE_OFFICES_SUBCATEGORY]: {
    name: 'PRIVATE OFFICES',
    color: '#A967E8',
    gradientColorIndex: 10,
  },
  [SHARED_SPACES_CATEGORY]: {
    name: 'SHARED SPACES',
    color: '#CBCBCB',
    gradientColorIndex: null,
  },
};

export const parseCategoriesListToMap = (
  categories: BenchmarkReportCategory[]
) => {
  return categories.reduce((categoriesMap, category) => {
    return {
      ...categoriesMap,
      [category.defaultCategory]: {
        ...category,
        name: category.name.toUpperCase().trim(),
      },
    };
  }, {});
};

export const buildDefaultCategories = (organizationColors: IProjectColors) => {
  return Object.entries(DEFAULT_CATEGORIES_MAP).reduce(
    (newCategories, [key, values]) => {
      if (
        [
          INDIVIDUAL_WORKSPACES_CATEGORY,
          WORKSTATIONS_SUBCATEGORY,
          PRIVATE_OFFICES_SUBCATEGORY,
          CUSTOM_SUBCATEGORY,
        ].includes(key)
      ) {
        return {
          ...newCategories,
          [key]: {
            ...values,
            color: organizationColors[INDIVIDUAL_WORKSPACES_CATEGORY],
          },
        };
      }

      if (organizationColors[key])
        return {
          ...newCategories,
          [key]: { ...values, color: organizationColors[key] },
        };
      return { ...newCategories, [key]: values };
    },
    {}
  );
};
